import cx from 'classnames';
import React from 'react';

import loadingAnimationBg from '@skippay/core/assets/illustrations/loading-animation-bg.png';
import loadingAnimation from '@skippay/core/assets/illustrations/loading-animation.png';
import Text from '@skippay/core/components/Text';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import classes from './index.module.sass';

interface Props {
	extraSmall?: boolean;
	fullSize?: boolean;
	isFixed?: boolean;
	large?: boolean;
	message?: JSX.Element | string;
	small?: boolean;
	style?: React.CSSProperties;
}

function Loader(props: Props): JSX.Element {
	const {
		extraSmall,
		fullSize,
		isFixed,
		large,
		message = <FormattedMessage defaultMessage="Probíhá načítání" id="Loader.title" />,
		small,
	} = props;

	return (
		<div
			className={cx(
				classes.content,
				extraSmall && classes.extraSmall,
				small && classes.small,
				large && classes.large,
				fullSize && classes.fullSize,
				isFixed && classes.isFixed
			)}
			style={props.style}
		>
			<div className={classes.loader}>
				<img src={loadingAnimation} alt="" />
				<img src={loadingAnimationBg} alt="" />
				<svg className={classes.circularLoader} viewBox="25 25 50 50">
					<circle
						className={classes.loaderPath}
						cx="50"
						cy="50"
						r="20"
						fill="none"
						stroke="currentColor"
						strokeWidth="1.5"
					/>
				</svg>
				<div className={classes.circle} />
			</div>

			{!extraSmall && !small && Boolean(message) && (
				<Text align="center" as="strong">
					{message}
					...
				</Text>
			)}
		</div>
	);
}

export default Loader;
